import { createTransaction, getUsdEthRates } from 'APIs/transactionApi';
import { db } from 'app/firebase';
import { ethers } from 'ethers';
import { addTransaction } from 'features/auth/authSlice';
import { doc, updateDoc } from 'firebase/firestore';
import { SetStateAction } from 'react';
import { Dispatch } from 'redux';
import abi from '../abi.json';
import abi_mint from '../abi_mint.json';
import { getRef } from './Firebase.util';

export const sendEther = async (
  ether: string,
  recipientAddress: string,
  setError: SetStateAction<any>,
  setTransaction: SetStateAction<any>,
  setLoading: SetStateAction<any>,
  setIsSubscribed: SetStateAction<any>,
  senderId: string,
  recieverId: string,
  dispatch: Dispatch,
  isPost: boolean,
  price: string,
  postId?: number,
  msgId?: string,
  authId?: number,
  userId?: number
) => {
  try {
    const ethereum = window.ethereum;
    const contractAddress = process.env.REACT_APP_CONTRACT_ADDRESS as string;
    if (ethereum) {
      const provider = new ethers.providers.Web3Provider(ethereum);
      await provider.send('eth_requestAccounts', []);
      const usd = await getUsdEthRates();
      const originalPrice = price;
      price = (parseFloat(price) / usd.USD).toFixed(6);
      const signer = provider.getSigner();
      const contract = new ethers.Contract(contractAddress, abi, signer);
      setLoading(true);
      const transaction = await contract.setReceiver(recipientAddress, {
        value: ethers.utils.parseEther(price),
      });
      const res = await createTransaction({
        from: senderId,
        to: recieverId,
        hash: transaction.hash,
        isPost,
        postId,
        isProcessed: false,
        amount: !isPost ? originalPrice : price,
        amountUsd: !isPost ? price : originalPrice,
        receipt: `https://goerli.etherscan.io/tx/${transaction.hash}`,
      });
      if (res.data) {
        dispatch(addTransaction(res.data));
        try {
          if (msgId && authId && userId && msgId) {
            const dbRef = await getRef(authId, userId);
            if (dbRef)
              await updateDoc(doc(db, 'chats', dbRef, 'messages', msgId), {
                isPending: true,
              });
          }
        } catch (error) {
          console.log(error);
        }
      }
      setLoading(false);
      setTransaction(true);
      setError('');
      setIsSubscribed(true);
      await transaction.wait();
    } else {
      throw new Error('Wallet not found! Please install MetaMask wallet.');
    }
  } catch (error: any) {
    console.log(error);
    setError(error.message);
    setTransaction(false);
    setLoading(false);
    setIsSubscribed(false);
  }
};

export const checkStatus = async (hash: string, dispatch: Dispatch) => {
  const ethereum = window.ethereum;
  if (ethereum) {
    const provider = new ethers.providers.Web3Provider(ethereum);
    await provider.send('eth_requestAccounts', []);
    const transaction = await provider.getTransaction(hash);
    if (transaction.blockNumber) {
      return true;
    } else return false;
  }
};

export const mintNft = async (
  recipientAddress: string,
  tokenId: number,
  name: string,
  description: string,
  image: string,
  nftId: number
) => {
  const ethereum = window.ethereum;
  const contractAddress = process.env.REACT_APP_MINT_CONTRACT_ADDRESS as string;
  if (ethereum) {
    const provider = new ethers.providers.Web3Provider(ethereum);
    await provider.send('eth_requestAccounts', []);
    const signer = provider.getSigner();
    const contract = new ethers.Contract(contractAddress, abi_mint, signer);
    await contract.mint(
      recipientAddress,
      tokenId,
      name,
      description,
      image,
      nftId
    );
  }
};
